import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'
import moment from 'moment'

export async function getVehicleAndPeopleFlow(condition = {}) {
  // 單一景區人車流
  if (Utils.isEmptyObject(condition.id) || condition.id < 0) {
    console.error('iisi getVehicleAndPeopleFlow: scenicAreaId is null or id < 0')
    return
  }

  let response = {}
  let scenicAreaId = condition.id
  let timestamp = moment().format().split('+')[0]
  // let timestamp = "2023-09-11T23:59:00"
  // let timestamp = "2025-02-05T23:59:00"

  // let timestamp = moment().format("YYYY-MM-DD HH:mm").split('+')[0];
  let encodeTimestamp = encodeURIComponent(timestamp)
  let idAndTimeQuery = `?scenicAreaID=${scenicAreaId}&endTime=${encodeTimestamp}`
  try {
      response = await axios.get(`${config.eastCoastMonitorApi()}Elastic/GetVehicleAndPeopleFlow${idAndTimeQuery}`)

  } catch (err) {
      console.error('iisi getVehicleAndPeopleFlow: ', err)
  }

  Utils.setApiResponsSuccess(response)
  handleSeries(response.data)
  return response
  
}

function handleSeries(data) {
  // 首頁圓餅圖資料
  if(Utils.isEmptyObject(data)) {
    return
  }

  const busSeries = []
  const carSeries = []
  const motoSeries = []

  //首頁大型車在園 = BUS_INSITE + SMALL_BUS_INSITE
  data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_INSITE_FLOW] = data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_INSITE_FLOW] +
                                                    data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.SMALLBUS_INSITE_FLOW]


  busSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_INSITE_FLOW])
  busSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_PARKING_SPACE] - 
    data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_INSITE_FLOW])

  carSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_INSITE_FLOW])
  carSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_PARKING_SPACE] - 
    data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_INSITE_FLOW])

  motoSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_INSITE_FLOW])
  motoSeries.push( data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_PARKING_SPACE] - 
    data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTOCYCLE_INSITE_FLOW])


  data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.BUS_SERIES] = busSeries
  data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.CAR_SERIES] = carSeries
  data[CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.VEHICLE_FLOW_DATA][CONST.HOME_PAGE_VEHICLE_PEOPLE_ITEM.MOTO_SERIES] = motoSeries
}

export async function getToiletFlow(condition = {}) {
  if (Utils.isEmptyObject(condition.id) || condition.id < 0) {
    console.error('iisi getToiletFlow: scenicAreaId is null or id < 0')
    return
  }

  let response = {}
  let scenicAreaId = condition.id
  let timestamp = moment().format()
  let encodeTimestamp = encodeURIComponent(timestamp)
  let idAndTimeQuery = `?scenicAreaID=${scenicAreaId}&endTime=${encodeTimestamp}`

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Elastic/GetToiletFlow${idAndTimeQuery}`)

  } catch (err) {
    console.error('iisi getToiletFlow: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function GetAllScenicAreaVehicleAndPeopleFlow(condition = {}) {
  let response = {}
  let endTime = moment().format().split('+')[0] // 現在時間  //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let encodeEndTime = encodeURIComponent(endTime)
  let endTimeQuery = `?endTime=${encodeEndTime}`

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Elastic/GetAllScenicAreaVehicleAndPeopleFlow${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetAllScenicAreaVehicleAndPeopleFlow: ', err)
    response.data = {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}